export enum ActionType {
  LOADED = 'LOADED',
  FETCH_START = 'FETCH_START',
  FETCH_END = 'FETCH_END',
  SWITCH_QUERY = 'SWITCH_QUERY',
  CLEAR_RESULTS = 'CLEAR_RESULTS'
}
